import { createAction, props } from '@ngrx/store';
import { CompanyContact } from '@src/app/core/types/company-contact.type';

const loadCompanyContacts = createAction('[Company Contacts] Load Contacts');
const loadCompanyContactsSuccess = createAction(
  '[Company Contacts] Load Contacts Success',
  props<{ contacts: CompanyContact[] }>(),
);
const loadCompanyContactsFailure = createAction(
  '[Company Contacts] Load Contacts Failure',
  props<{ error: any }>(),
);

const addCompanyContact = createAction(
  '[Company Contacts] Add Contact',
  props<{ contact: CompanyContact }>(),
);
const addCompanyContactSuccess = createAction(
  '[Company Contacts] Add Contact Success',
  props<{ contact: CompanyContact }>(),
);
const addCompanyContactFailure = createAction(
  '[Company Contacts] Add Contact Failure',
  props<{ error: any }>(),
);

const updateCompanyContact = createAction(
  '[Company Contacts] Update Contact',
  props<{ contact: CompanyContact }>(),
);
const updateCompanyContactSuccess = createAction(
  '[Company Contacts] Update Contact Success',
  props<{ contact: CompanyContact }>(),
);
const updateCompanyContactFailure = createAction(
  '[Company Contacts] Update Contact Failure',
  props<{ error: any }>(),
);

const updateContactProfiles = createAction(
  '[Company Contacts] Update Contact Profiles',
  props<{ contactId: string; profiles: string[] }>(),
);
const updateContactProfilesSuccess = createAction(
  '[Company Contacts] Update Contact Profiles Success',
  props<{ contact: CompanyContact }>(),
);
const updateContactProfilesFailure = createAction(
  '[Company Contacts] Update Contact Profiles Failure',
  props<{ error: any }>(),
);

const deleteCompanyContact = createAction(
  '[Company Contacts] Delete Contact',
  props<{ contactId: string }>(),
);
const deleteCompanyContactSuccess = createAction(
  '[Company Contacts] Delete Contact Success',
  props<{ contactId: string }>(),
);
const deleteCompanyContactFailure = createAction(
  '[Company Contacts] Delete Contact Failure',
  props<{ error: any }>(),
);

export const CompanyContactsActions = {
  loadCompanyContacts,
  loadCompanyContactsSuccess,
  loadCompanyContactsFailure,
  addCompanyContact,
  addCompanyContactSuccess,
  addCompanyContactFailure,
  updateCompanyContact,
  updateCompanyContactSuccess,
  updateCompanyContactFailure,
  updateContactProfiles,
  updateContactProfilesSuccess,
  updateContactProfilesFailure,
  deleteCompanyContact,
  deleteCompanyContactSuccess,
  deleteCompanyContactFailure,
};
